export default __webpack_public_path__ + "static/map-114a6b3cb833173abf000d2650fe8756.jpg";